@if (product && (jsonLdSchema$ | async)) {
  <app-json-ld [json]="jsonLdSchema$ | async"></app-json-ld>
}
